<template>
  <v-card flat  class="setup-subtab-content">

    <div>
      <div class="font-weight-bold">
        {{ $t('setup.journalPricelist') }}
      </div>
      <div>
        <span v-html="$t('setup.pricelistInstructions')"></span>
        <code>.csv</code>,
        <code>.xlsx</code>, {{ $t('setup.pricelistFormats') }}
        <code>.xls</code>.
      </div>
      <div class="mt-3 mb-2">
        <img
          src="https://docs.unsub.org/~gitbook/image?url=https%3A%2F%2F2329511114-files.gitbook.io%2F%7E%2Ffiles%2Fv0%2Fb%2Fgitbook-x-prod.appspot.com%2Fo%2Fspaces%252FeIwtiPevlQYuy1bQ4x85%252Fuploads%252FjWYr4tXwXNGFQVOpgIUu%252FScreen%2520Shot%25202022-10-19%2520at%25209.44.07%2520AM.png%3Falt%3Dmedia%26token%3D1db4377b-d165-4d78-9a72-e32791454d43&width=768&dpr=1&quality=100&sign=71846101dd772a71ef5dde0305cbd12b&sv=3"
          alt="Pricelist file example"
          style="max-width: 100%; border: 1px solid #e0e0e0; border-radius: 4px;"
        />
      </div>

      <div class="mt-6 mb-2">
        <div class="font-weight-bold mb-1">
          {{ $t('setup.priceCurrencyLabel') }}
        </div>
        <div class="body-2 mb-2">
          {{ $t('setup.priceCurrencyDescription') }}
        </div>
        <div class="d-flex align-center" style="max-width: 300px;">
          <v-select
              v-model="selectedPriceCurrency"
              :items="currencyOptions"
              outlined
              dense
              hide-details
              @change="savePriceCurrency"
              :loading="isSaving"
          />
        </div>
      </div>

      <v-list>
        <publisher-file file-type="price" />
      </v-list>

    </div>
  </v-card>


</template>


<script>
import _ from "lodash"
import {mapGetters, mapMutations, mapActions} from 'vuex'
import {api} from "@/api";
import PublisherFile from "../PulisherFile/PublisherFile";
import PublisherWarning from "@/components/PublisherWarning/PublisherWarning";


export default {
  name: "PublisherSetupTabPricelist",
  components: {
    PublisherFile,
    PublisherWarning,
  },
  props: {},
  data() {
    return {
      selectedPriceCurrency: null,
      isSaving: false,
    }
  },
  methods: {
    ...mapMutations([
      "snackbar",
    ]),
    ...mapActions([
      "refreshPublisher",
    ]),
    async savePriceCurrency() {
      this.isSaving = true
      const path = `publisher/${this.publisherId}`
      try {
        await api.postFile(path, { price_currency: this.selectedPriceCurrency })
        await this.refreshPublisher()
        this.snackbar(this.$t('setup.priceCurrencySaved'))
      } catch (e) {
        console.log("error saving price currency", e)
      } finally {
        this.isSaving = false
      }
    },
  },
  computed: {
    ...mapGetters([
      "publisherName",
      "publisherId",
      "publisherBigDealCost",
      "publisherFiles",
      "getPublisherDataFile",
      "publisherCounterVersion",
      "publisherCurrency",
      "publisherPriceCurrency",
    ]),
    currencyOptions() {
      return [
        { text: "JPY (¥)", value: "JPY" },
        { text: "USD ($)", value: "USD" },
        { text: "EUR (€)", value: "EUR" },
        { text: "GBP (£)", value: "GBP" },
      ]
    },
  },
  created() {
    this.selectedPriceCurrency = this.publisherPriceCurrency || this.publisherCurrency || "JPY"
  },
  mounted() {

  },
  watch: {}
}
</script>

<style lang="scss">


</style>
